import { UploadChangeParam } from "antd/lib/upload";
import { useState } from "preact/hooks";
import { useMessage } from "../../../hooks/useMessage";
import {
  UPLOAD,
  UPLOAD_EXCEL,
  POST,
  CREATE_DEVICES,
  DOWLOAD_EXMAPLE_IMPORTED_DEVICE,
  DOWNLOAD,
} from "../../../services";
import { IStateUpload } from "../interfaces/state";

export const useFileExcell = () => {
  const { openMessage } = useMessage();
  const [stateUpload, setStateUpload] = useState([] as IStateUpload[]);
  const [stateUploadError, setStateUploadError] = useState(
    [] as IStateUpload[]
  );
  const [loadingPreviewError, setLoadingPreviewError] = useState(false);
  const [fileUpload, setFileUpload] = useState([] as any);
  const [importErrMsg, setImportErrMsg] = useState("");

  const dowloadExmapleImportedDevice = async () => {
    const res: any = await DOWNLOAD(DOWLOAD_EXMAPLE_IMPORTED_DEVICE);
    const url = window.URL.createObjectURL(new Blob([res]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"ExampleimportDevice"}_Data.xlsx`);
    document.body.appendChild(link);
    link.click();
    if (!res) {
      throw new Error("get excel error");
    }
  };

  const onUploadFileExcel = async (data: UploadChangeParam) => {
    setLoadingPreviewError(true);
    setFileUpload(data.fileList);
    try {
      if (!data.file || data.file.status === "removed") {
        setStateUploadError([]);
        setStateUpload([]);
      }
      const form = new FormData();
      form.append("file", data.file as any);
      const res: any = await UPLOAD(UPLOAD_EXCEL, form);
      const { devices } = res.result;
      const newData: IStateUpload[] = devices.map(
        (e: IStateUpload, i: number) => ({
          ...e,
          index: i + 1,
          key: e.deviceID,
        })
      );
      if (data.file) {
        setStateUpload(newData);
        setStateUploadError(newData.filter((e) => e.error));
        setLoadingPreviewError(false);
        const checkError = newData.find((element) => {
          if (element.error) {
            return true;
          } else {
            return;
          }
        });
        if (checkError) {
          openMessage("error", "ข้อมูลไฟล์ผิดพลาด กรุณาตรวจสอบอีกครั้ง");
        } else {
          setLoadingPreviewError(false);
          openMessage("success", "ข้อมูลไฟล์ถูกต้อง");
        }
      }
    } catch (error: any) {
      console.log(error);
      setLoadingPreviewError(false);
    }
  };

  const onSaveUploadFileExcel = async (data: any) => {
    setImportErrMsg("");
    try {
      const res: any = await POST(CREATE_DEVICES, { devices: data });
      openMessage("success", res.message);
      if (res.success) {
        setFileUpload([]);
        setStateUpload([]);
      }
      return true;
    } catch (error: any) {
      setImportErrMsg(error.message);
      openMessage("error", error.message);
      return false;
    }
  };
  return {
    stateUpload,
    stateUploadError,
    onUploadFileExcel,
    onSaveUploadFileExcel,
    dowloadExmapleImportedDevice,
    loadingPreviewError,
    fileUpload,
    setFileUpload,
    setStateUpload,
    importErrMsg,
  };
};
